/**
 * Opens the cart drawer when the URL contains ?cart=open (e.g. after redirect from /cart).
 * Strips the param from the address bar so the link stays shareable/bookmarkable.
 */
(function () {
  function cleanSearchParam() {
    var url = new URL(window.location.href);
    if (url.searchParams.get('cart') !== 'open') return;
    url.searchParams.delete('cart');
    var qs = url.searchParams.toString();
    var next = url.pathname + (qs ? '?' + qs : '') + url.hash;
    window.history.replaceState({}, '', next);
  }

  function showDrawer() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('cart') !== 'open') return;
    cleanSearchParam();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.show === 'function') {
      drawer.show();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      customElements.whenDefined('cart-drawer').then(showDrawer);
    });
  } else {
    customElements.whenDefined('cart-drawer').then(showDrawer);
  }
})();
